import { render } from "./Myfiles.vue?vue&type=template&id=327c1a41&scoped=true"
import script from "./Myfiles.vue?vue&type=script&lang=js"
export * from "./Myfiles.vue?vue&type=script&lang=js"

import "./Myfiles.vue?vue&type=style&index=0&id=327c1a41&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ardent_dms_v2\\ardent_dms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327c1a41"]])

export default __exports__